import { createMediaLibrary } from '@adornis/web-editor/client/media/MediaLibrary.js';
import { LandingEditorClient } from '../editor/landingEditorClient.js';
export const { EditorMediaLibrary, EditorMediaInspector, renderEditorMediaLibrary, renderEditorMediaInspector } = createMediaLibrary(LandingEditorClient);
